import React from 'react';
import { Redirect } from 'react-router-dom';

import { isNonLocalNonLoggedInVisitor } from '../../utils/utils';

import Dashboard from '../Dashboard';

const UserHome = () => {
  if (isNonLocalNonLoggedInVisitor()) {
    return <Redirect to="/homeDispatcher" />;
  } else {
    return <Dashboard />;
  }
};

export default UserHome;
